import { DesktopIcon, MobileIcon } from '@radix-ui/react-icons';

import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';

export function EditorModeSwitcher({
  value,
  onChange,
}: {
  value: 'stage' | 'mobile';
  onChange: (value: 'stage' | 'mobile') => void;
}) {
  return (
    <div className="flex items-center gap-2">
      <ToggleGroup
        type="single"
        value={value}
        onValueChange={(value: 'stage' | 'mobile') => {
          if (value) onChange(value);
        }}
      >
        <ToggleGroupItem value="stage" aria-label="Stage View">
          <DesktopIcon className="h-4 w-4" />
          <span className="hidden md:block">stage</span>
        </ToggleGroupItem>
        <ToggleGroupItem value="mobile" aria-label="Mobile View">
          <MobileIcon className="h-4 w-4" />
          <span className="hidden md:block">mobile</span>
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
}
